<template>
  <div class="seminar-client">
    <title-screen title="6"></title-screen>
    <p class="title">
        レガシィが開催するセミナーへご参加いただけます。セミナーのご参加は会員登録が必要ですので、会員登録がお済みでない方は、先に会員登録を行ってからセミナーへのご参加申し込みをお願いいたします。
    </p>
    <div class="content-info" id="content-info">
      <div v-for="group in groups" :key="group.seminarGroupId" class="group-panel">
        <div class="table1-title border-radius">
          <span style="padding-bottom: 10px; border-bottom: 4px solid black">{{ group.groupName }}</span>
        </div>
        <SeminarTable
          :data="group.seminars"
          :group-id="group.groupId"
          @handleJoin="handleJoin"
          @handleUnJoin="handleUnJoin"/>
      </div>
      <div style="height:5px; width:100%; clear:both;"></div>
    </div>

    <!-- Dialog Join UnAuthenticated -->
    <el-dialog
      :visible.sync="dialogUnAuthenticateVisible"
      :show-close="false"
      width="50%">
      <div class="messages">
        <span>セミナーへの参加は会員様限定となっています。</span><br>
        <span>会員登録がお済みの方は、事前にログインを行って頂く必要</span><br>
        <span>があります。下の「ログイン」ボタンをクリックしてログインを</span><br>
        <span>行ってください。</span>
      </div>
      <div class="button-panel">
        <el-button @click="openLoginDialog">ログイン</el-button>
      </div>
      <div class="messages">
        <span>会員登録がお済みでない方は、先に「会員登録」を行って頂く必要がございます。</span><br>
        <span>会員登録を行うには、下の「会員登録」ボタンをクリックしてください。</span><br>
        <span>会員登録後に再度セミナーへの参加ボタンを押してセミナー参加を行ってください</span>
      </div>
      <div class="button-panel">
        <el-button @click="goToRegisterPage">会員登録</el-button>
      </div>
      <div class="button-panel-right">
        <el-button @click="dialogUnAuthenticateVisible = false">閉じる</el-button>
      </div>
    </el-dialog>

    <!-- Dialog UnJoin Authenticated -->
    <el-dialog
      :visible.sync="dialogCancelVisible"
      :show-close="false"
      width="30%">
      <el-form
        class="cancel-form"
        ref="cancelForm"
        @submit.native.prevent="submitUnJoinForm('cancelForm')"
        label-width="120px"
      >
        <div class="messages-title">
          <span>相続無料セミナーの申し込みの取り消しを行います。</span><br>
        </div>
        <div class="messages-content">
          <span>開催日： {{ startDate }}</span><br>
          <span>開催時間：{{ startTime }}</span><br>
          <span v-html="getVenueHtmlPlace(venue)"></span><br>
        </div>
        <div class="button-panel-left text-center-mobile">
          <el-button @click="closeCancelDialog">キャンセル</el-button>
          <el-button class="button-right" native-type="submit">OK</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import ApiSeminarClient from '@/api/seminar/seminar-client.js'
    import SeminarTable from './SeminarTable.vue'
    import { SET_OPEN_LOGIN_DIALOG, SET_OPEN_REGISTER_DIALOG } from '@/store/actions.type'
    import TitleScreen from '@/components/common/TitleScreen'

    const EXTERNAL_FORM_GROUP_ID = 1
    const EXTERNAL_FORM_URL = 'https://forms.cloud.microsoft/r/Z1WxGjvwzi'

    export default {
        name: 'seminar',
        data () {
            return {
                groups: [],
                dialogUnAuthenticateVisible: false,
                dialogCancelVisible: false,
                startTime: '',
                startDate: '',
                venue: '',
                payload: {},
                paramId: 0,
                dialogVisible: true
            }
        },
        components: {
            SeminarTable,
            'title-screen': TitleScreen
        },
        created () {
            this.fetchData()
            this.$bus.$on('refreshData', (data) => {
                if (this.$route.name === data) {
                    this.fetchData()
                }
            })
            this.openDialogUnjoin()
        },
        destroyed () {
            this.$bus.$off('refreshData', () => {
                this.fetchData()
            })
        },
        watch: {
            '$route' (to, from) {
                return this.fetchData()
            }
        },
        computed: {
            ...mapGetters(['currentUser', 'isAuthenticated'])
        },
        methods: {
            handleJoin (row) {
                if (row.groupId === EXTERNAL_FORM_GROUP_ID) {
                    window.open(EXTERNAL_FORM_URL, '_blank')
                    return
                }

                this.paramId = row.id
                if (this.isAuthenticated) {
                    this.$router.push({ name: 'seminarJoin', params: { id: row.id } })
                } else {
                    this.dialogUnAuthenticateVisible = true
                }
                this.payload = {
                    seminarId: row.id,
                    memberId: 1,
                    participationFlag: 1,
                    freeConsultationFlag: 1,
                    consultationPurpose: '',
                    inheritanceDate: ''
                }
            },
            handleUnJoin (row) {
                this.paramId = row
                this.dialogCancelVisible = true
                this.startDate = row.exhibitionDate
                this.startTime = row.exhibitionTime
                this.venue = row.venue
                this.payload = {
                    id: row.participantId
                }
            },
            fetchData () {
                let memberId = this.currentUser.id === undefined ? 0 : this.currentUser.id
                if (memberId > 0 && this.paramId > 0) {
                    this.$router.push({ name: 'seminarJoin', params: { id: this.paramId } })
                }
                ApiSeminarClient.getSeminarList(memberId).then(response => {
                    if (response.data.status === 200) {
                        this.groups = response.data.data
                    }
                })
            },
            submitUnJoinForm (formName) {
                ApiSeminarClient.cancelSeminar(this.payload).then(response => {
                    if (response.data.status === 200) {
                        this.dialogCancelVisible = false
                        this.fetchData()
                    }
                })
            },
            openLoginDialog () {
                this.$store.dispatch(SET_OPEN_LOGIN_DIALOG, true)
                this.fetchData()
                this.dialogUnAuthenticateVisible = false
            },
            goToRegisterPage () {
                this.$store.dispatch(SET_OPEN_REGISTER_DIALOG, true)
                this.fetchData()
                this.dialogUnAuthenticateVisible = false
            },
            closeCancelDialog () {
                this.dialogCancelVisible = false
            },
            openDialogUnjoin () {
                let join = this.$route.params.join
                if (join === true) {
                    this.$alert('既に参加済みです。', '', {
                        confirmButtonText: 'OK'
                    })
                }
            },
            getVenueHtmlPlace (venue) {
              let venueAry = venue.split('　')
              let output = '開催場所：'
              venueAry.forEach(element => {
                output = output + element + '<br>'
              })
              return output
            }
        }
    }
</script>

<style>
  @import './seminar.css';
  @import '../../../../assets/css/custom.css';
</style>
<style scoped>
    .seminar-client .note {
        display: block !important;
    }
</style>
